/* eslint-disable no-console */
import Auth from '../../api/Auth';
import BasicNotification from '../../shared/components/Notifications/BasicNotification';

export const restPassword = (data, cb) => async () => {
  BasicNotification.info('Enviando correo...');
  try {
    const { body } = await Auth.restPassword(data);
    if (cb) {
      cb(body);
    }
    BasicNotification.info('Si tu email existe, recibirás un correo con la clave para restablecer tu contraseña.');
  } catch (error) {
    if (error.status === 500) {
      BasicNotification.error('Ocurrió un error al intentar resetear la contraseña.');
    } else {
      BasicNotification.info('Si tu email existe, recibirás un correo con la clave para restablecer tu contraseña.');
    }
  }
};

export const signIn = (data, cb) => async () => {
  try {
    const { body } = await Auth.signIn(data);
    if (cb) {
      cb(body);
    }
  } catch (error) {
    console.error(error);
    BasicNotification.error('Ocurrió un error al intentar iniciar sesión.');
  }
};
